var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.accessType !== "NoAccess"
    ? _c(
        "div",
        [
          _c("page-header", {
            attrs: {
              page: _vm.pageHeaderConfig,
              "right-side-class":
                "col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "customActions",
                  fn: function() {
                    return [
                      _vm.isAdmin
                        ? _c("dropdown", {
                            staticClass: "reports-dropdown actions-dropdown",
                            attrs: {
                              icon: "fas fa-folders",
                              items: _vm.dropdownHeaderActions,
                              responsive: "",
                              title: "Informes"
                            }
                          })
                        : _vm._e(),
                      _vm.isAdmin
                        ? _c(
                            "action-button",
                            {
                              staticClass: "mr-2 d-block",
                              attrs: {
                                i: "fas fa-key",
                                responsive: "",
                                variant: "outline-success"
                              },
                              on: { click: _vm.goToTokenHistory }
                            },
                            [_vm._v(" Solicitud de Token ")]
                          )
                        : _vm._e(),
                      _vm.isAdmin
                        ? _c(
                            "action-button",
                            {
                              attrs: {
                                i: "fas fa-users pr-1",
                                responsive: "",
                                variant: "success"
                              },
                              on: { click: _vm.goToEvaluators }
                            },
                            [_vm._v(" Evaluadores ")]
                          )
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1949910415
            )
          }),
          _c(
            "div",
            {
              staticClass: "service-proposal-history__filter-manager-wrapper",
              class: {
                "service-proposal-history__filter-manager-wrapper--provider":
                  _vm.isProvider,
                "service-proposal-history__filter-manager-wrapper--isAdmin":
                  _vm.isAdmin,
                "service-proposal-history__filter-manager-wrapper--evaluator":
                  _vm.isEvaluator
              }
            },
            [
              _c("filter-manager", {
                staticClass: "service-proposal-history__filter-manager",
                attrs: {
                  "display-advanced": _vm.isAdmin,
                  filters: _vm.filtersConfig,
                  "search-container-class": _vm.searchContainerClass
                },
                on: {
                  search: function($event) {
                    return _vm.search()
                  },
                  "update:openAdvanced": _vm.advanceSearchHandler
                },
                model: {
                  value: _vm.selectedFilters,
                  callback: function($$v) {
                    _vm.selectedFilters = $$v
                  },
                  expression: "selectedFilters"
                }
              })
            ],
            1
          ),
          _c("custom-separator", {
            staticClass: "pt-3 my-4",
            attrs: { text: "Propuestas de Servicios" }
          }),
          _c("callout-list", {
            attrs: { "access-type": _vm.accessType, data: _vm.results },
            on: { "on-proposal-status-change": _vm.search }
          }),
          _vm.results.length === 0
            ? _c("custom-result-not-found", {
                attrs: { text: "No hay información disponible" }
              })
            : _vm._e(),
          _vm.results.length > 0 && _vm.pagination.totalItemCount > _vm.pageSize
            ? _c("pagination", {
                attrs: { data: _vm.pagination, "show-text": true },
                on: { "pagination-go-page": _vm.search }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }